import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ICourse } from './../../shared/models/course';

@Component({
  selector: 'app-all-courses',
  templateUrl: './all-courses.component.html',
  styleUrls: ['./all-courses.component.css']
})
export class AllCoursesComponent implements OnInit {

  @Input() courseList: Array<ICourse> = [];
  @Input() isShowAll: boolean = false;
  constructor(private route: Router) { }

  ngOnInit(): void {
    console.log('isShowAll:=', this.isShowAll);
  }

  //[routerLink] ="['/view-course-details']"
  gotoCourseDetail(course: ICourse) {
    if (sessionStorage.UserId)
      this.route.navigate(['view-course-details'], { state: course });
    else
      this.route.navigate(['eRP/view-course-details'], { state: course });

  }
}